import React, { PropsWithChildren, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { GradientTitle, StyledSubtitle } from '../../components/styled/StyledComponents';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { MainListItems, secondaryListItems } from '../components/menu-aside';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiDrawer from '@mui/material/Drawer';
import {
    Link,
    useLocation,
    useNavigate, LinkProps
} from 'react-router-dom';
import { Avatar, Box, ListItemButton, ListSubheader, Menu, MenuItem, Chip } from '@mui/material';
import { useBaseInternalFormState } from './context/base-internal-form-context';
import { useBaseInternalFormController } from './context/base-internal-form-controller';
import { ACTION_TYPES, useGlobalDispatch, useGlobalState } from '../global/context/global-context';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ApplicationAppService from '../../application/platform/application-app-service';


interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

interface BaseInternalFormProps extends PropsWithChildren {
    pagetTitle: string;
    urlBeforeAction?: string;
}


// function LinkRouter(props: LinkRouterProps) {
//     return <Link {...props} component={RouterLink as any} />;
// }

const breadcrumbNameMap: { [key: string]: string } = {
    '/diario-oficial': 'Diário Oficial',
    '/diario-oficial/detalhes': 'Detalhes da Edição',
    '/diario-oficial/publicar': 'Publicar no Diário Oficial',
    '/remessas-publicacao': 'Remessas',
    '/remessas-publicacao/detalhes': 'Detalhes da Remessa',
};

export const BaseInternalForm: React.FC<BaseInternalFormProps> = (props) => {
    const { drawerWidth, drawerOpen } = useBaseInternalFormState();
    const { authenticationData, applicationData } = useGlobalState();
    const { toggleDrawer, logout } = useBaseInternalFormController();
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate();
    const globalDispatch = useGlobalDispatch();

    // Fallback para carregar applicationData se não estiver no contexto global
    const currentApplicationData = applicationData || ApplicationAppService.getApplicationData();

    useEffect(() => {

        if (authenticationData === null || authenticationData === undefined) {
            var storeAuthenticationData = ApplicationAppService.getAuthenticationData();
            if (storeAuthenticationData === null || storeAuthenticationData === undefined) {
                navigate(`/unauthorized`);
            } else {
                globalDispatch({
                    type: ACTION_TYPES.setAuthenticationData,
                    payload: storeAuthenticationData,
                });
            }
        }
    }, [authenticationData])

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };
    const AppBar = styled(MuiAppBar, {
        shouldForwardProp: (prop) => prop !== 'open',
    })<AppBarProps>(({ theme, open }) => ({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }));

    const Copyright = (props: any) => {
        return (
            <StyledSubtitle variant="body2" align="center" sx={{ mt: 2 }} {...props}>
                {'Copyright © '}
                <Link color="inherit" target={'_blank'} to="http://www.munidados.com.br/" style={{ fontWeight: 500 }}>
                    www.munidados.com.br
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </StyledSubtitle>
        );
    }

    const PageTitle = () => {
        const location = useLocation();
        const pathnames = location.pathname.split('/').filter((x) => x);

        // Verificar se há items para mostrar no breadcrumb
        const hasDashboardLink = location.pathname !== '/dashboard';
        const hasPathItems = pathnames.some((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            return breadcrumbNameMap[to] !== undefined;
        });
        const showBreadcrumbs = hasDashboardLink || hasPathItems;

        return (<Grid container spacing={2}>
            <Grid item xs={showBreadcrumbs ? 8 : 12} md={showBreadcrumbs ? 8 : 12} lg={showBreadcrumbs ? 8 : 12}>
                <React.Fragment>
                    <GradientTitle variant="h4" component="div" sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', mb: 1 }}>
                        {props.urlBeforeAction && (
                            <IconButton color="primary" aria-label="Voltar" size='large' onClick={() => {
                                if (props.urlBeforeAction !== undefined) {
                                    window.location.href = props.urlBeforeAction;
                                }
                            }
                            } sx={{ mr: 1 }}>
                                <ArrowBackIcon />
                            </IconButton>)}
                        {props.pagetTitle}
                    </GradientTitle>
                </React.Fragment>
            </Grid>
            {showBreadcrumbs && (
                <Grid item xs={4} md={4} lg={4} sx={{
                    display: 'flex',
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-end"

                }}>
                    <Box
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: 2,
                            padding: '8px 16px',
                            marginBottom: 1,
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        <Breadcrumbs 
                        aria-label="breadcrumb"
                        separator={<NavigateNextIcon fontSize="small" sx={{ color: 'text.secondary' }} />}
                        sx={{
                            '& .MuiBreadcrumbs-separator': {
                                margin: '0 8px'
                            }
                        }}
                    >
                        {location.pathname !== '/dashboard' && (
                            <Chip
                                icon={<HomeIcon />}
                                label="Dashboard"
                                component={Link}
                                to="/dashboard"
                                clickable
                                variant="outlined"
                                size="small"
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    '&:hover': {
                                        backgroundColor: 'primary.light',
                                        color: 'white'
                                    },
                                    fontWeight: 500
                                }}
                            />
                        )}
                        {pathnames.map((value, index) => {
                            const last = index === pathnames.length - 1;
                            const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                            var bredcumbMap = breadcrumbNameMap[to];

                            if (last && bredcumbMap != undefined) {
                                return (
                                    <Chip
                                        key={to}
                                        label={bredcumbMap}
                                        variant="filled"
                                        size="small"
                                        sx={{
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            '& .MuiChip-label': {
                                                fontSize: '0.875rem'
                                            }
                                        }}
                                    />
                                );
                            } else if (bredcumbMap != undefined) {
                                return (
                                    <Chip
                                        key={to}
                                        label={bredcumbMap}
                                        component={Link}
                                        to={to}
                                        clickable
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            backgroundColor: 'transparent',
                                            border: '1px solid rgba(102, 126, 234, 0.3)',
                                            color: 'text.secondary',
                                            '&:hover': {
                                                backgroundColor: 'primary.light',
                                                color: 'white',
                                                border: '1px solid transparent'
                                            },
                                            fontWeight: 500,
                                            transition: 'all 0.3s ease'
                                        }}
                                    />
                                );
                            } else {
                                return null;
                            }
                        })}
                    </Breadcrumbs>
                </Box>
            </Grid>
            )}
        </Grid>);
    }

    const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
        ({ theme, open }) => ({
            '& .MuiDrawer-paper': {
                position: 'relative',
                whiteSpace: 'nowrap',
                width: drawerWidth,
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                boxSizing: 'border-box',
                ...(!open && {
                    overflowX: 'hidden',
                    transition: theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                    width: theme.spacing(7),
                    [theme.breakpoints.up('sm')]: {
                        width: theme.spacing(7),
                    },
                }),
            },
        }),
    );

    function stringToColor(string: string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name: string) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }

    return (
        <React.Fragment>
            <AppBar position="absolute" open={drawerOpen} >
                <Toolbar
                    sx={{
                        pr: '24px',
                    }}
                >
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={toggleDrawer}
                        sx={{
                            marginRight: '36px'
                        }}
                    >
                        {drawerOpen ? (
                            <ChevronLeftIcon />
                        ) : (
                            <MenuIcon />
                        )}
                    </IconButton>
                    <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, fontWeight: 600 }}
                    >
                        {authenticationData?.type === 1 ? "ENTIDADE: " : "EMPRESA: "} {authenticationData?.company.name}
                    </Typography>
                    {authenticationData && (
                        <Box sx={{ flexGrow: 0 }}>
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }} id="btn-avatar">
                                <Avatar  {...stringAvatar(authenticationData.user.name)} />
                            </IconButton>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem key={1} component={Link} to={`/dashboard`}>
                                    <Typography textAlign="center" fontWeight={500}>Dashboard</Typography>
                                </MenuItem>      
                                <MenuItem key={2} component={Link} to={`/perfil`}>
                                    <Typography textAlign="center" fontWeight={500}>Perfil</Typography>
                                </MenuItem>
                                <MenuItem key={3} onClick={() => {
                                    handleCloseUserMenu();
                                    logout();
                                }}>
                                    <Typography textAlign="center" fontWeight={500}>Sair</Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    )}
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={drawerOpen}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        px: [1],
                    }}
                >
                    <Box
                        component="img"
                        sx={{

                            maxWidth: { xs: 50, md: 239 },
                        }}

                        src={currentApplicationData?.imageLogo}
                    />

                </Toolbar>
                <Divider />
                <List component="nav" >
                    <MainListItems
                        applicationData={currentApplicationData}
                        authenticationData={authenticationData}
                    />
                    <Divider sx={{ my: 1 }} />
                    {drawerOpen ? (
                        <ListSubheader component="div">
                            Outras Opções
                        </ListSubheader>
                    ) : (
                        null
                    )}


                    {secondaryListItems(logout)}
                </List>
            </Drawer>
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    flexGrow: 1,
                    minHeight: '100vh'
                }}
            >
                <Toolbar />
                <Container maxWidth={'xl'} sx={{ mt: 4, mb: 4 }}>
                    <PageTitle></PageTitle>
                    <Divider sx={{ mb: 2 }}></Divider>
                    <Grid container sx={{ backgroundColor: 'white' }}  >
                        <Grid container spacing={2} marginLeft={1} marginBottom={3} marginTop={1} marginRight={3}
                        >
                            {props.children}
                        </Grid>
                    </Grid>

                    <Copyright sx={{
                        pt: 4,

                    }} />
                </Container>
            </Box>
        </React.Fragment>
    )
}